import { useEffect, useState } from "react";

const useSynchronizeForm = ({ setShowSubmit, formikRef, listChecks, setListChecks, sincronismos, setSincronismos, loading, refetchings }) => {

  const [forceUpdate, setForceUpdate] = useState(0);
  const [checkAll, setCheckAll] = useState(false);

  const handleCheck = (e, check, index) => {
    let obj = check;

    const objs = sincronismos.map((c, i) => {
      if (obj.table === c.table) {
        c.checked = e.target.checked;
      }
      return c;
    });

    setSincronismos(objs);

    setForceUpdate(forceUpdate + 1);

    const allChecked = sincronismos.filter((item) => item.checked).length == sincronismos.length;
    const anyChecked = sincronismos.filter((item) => item.checked).length > 0;

    setShowSubmit(anyChecked);
    setCheckAll(allChecked);
  };

  const handleCheckAll = (e) => {
    const checked = e.target.checked;

    setCheckAll(checked);


    const obj = sincronismos.map((check, index) => {
      check.checked = checked;
      return check;
    });

    setSincronismos(obj);

    const anyChecked = sincronismos.filter((item) => item.checked).length > 0;
    setShowSubmit(anyChecked);
  };

  const handleSubmit = () => {
    sincronismos.forEach((check) => {
      if (check.checked) {
        if (listChecks[check.table]) {
          refetchings[check.table]();
        }
        else {
          setListChecks((prevState) => ({
            ...prevState,
            [check.table]: check.checked
          }));
        }
      }
    })
  }

  useEffect(() => {
    if (loading) {
      setShowSubmit(false);
    }
    else {
      const anyChecked = sincronismos.filter((item) => item.checked).length > 0;
      setShowSubmit(anyChecked);
    }

  }, [loading]);

  return {
    handleCheck,
    handleCheckAll,
    checkAll,
    handleSubmit
  }
};

export default useSynchronizeForm;
